import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { API } from 'aws-amplify';
import { listVehicles } from '../graphql/queries'; // ✅ RUTA CORREGIDA
import { Link } from 'react-router-dom';
import Footer from './Footer'; 
import awsmobile from '../aws-exports'; 

// --- 1. FUNCIÓN AUXILIAR DE IMAGEN (CORREGIDA PARA VIMCAR) ---
const getS3ImageUrl = (imageKey) => {
    if (!imageKey) return 'placeholder.jpg';
    
    // 🟢 USANDO EL BUCKET QUE YA SABEMOS QUE FUNCIONA EN HOME
    const BUCKET_NAME = "amplify-vimcarbrokerwebnew-prodstable-cdd61-deployment"; 
    const REGION = "us-east-1"; 
    
    return `https://${BUCKET_NAME}.s3.${REGION}.amazonaws.com/public/${imageKey}`;
};

// --- 2. Componente de Tarjeta de Vehículo (Reutilizable) ---
// Mantenido igual, solo lo muevo para facilitar el uso en el archivo
const VehicleCard = ({ vehicle }) => (
    <div className="vehicle-card" style={{ 
        border: '1px solid #ccc', 
        padding: '15px', 
        margin: '10px', 
        width: '300px', 
        textAlign: 'center', 
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)', 
        backgroundColor: 'white',
        transition: 'transform 0.3s',
        minWidth: '250px',
        maxWidth: '90vw' 
    }}>
        <img 
            src={getS3ImageUrl(vehicle.imageKey)} 
            alt={`${vehicle.year} ${vehicle.make}`} 
            style={{ width: '100%', height: '200px', objectFit: 'cover', marginBottom: '10px', borderRadius: '4px' }}
            onError={(e) => { e.target.onerror = null; e.target.src = 'placeholder.jpg'; }}
        />
        <h3 style={{fontSize: '1.2em', margin: '10px 0'}}>{vehicle.year} {vehicle.make} {vehicle.model}</h3>
        <p style={{fontWeight: 'bold', color: '#dc3545', fontSize: '1.4em'}}>
            ${vehicle.price?.toLocaleString()}
        </p>
        <p style={{fontSize: '0.9em', color: '#6c757d'}}>
            Millas: {vehicle.mileage?.toLocaleString()} | Estado: {vehicle.titleStatus}
        </p>
        <Link to={`/vehiculo/${vehicle.id}`} style={{ textDecoration: 'none' }}>
            <button 
                style={{ 
                    padding: '8px 15px', 
                    marginTop: '10px', 
                    backgroundColor: '#007bff', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '4px', 
                    cursor: 'pointer', 
                    fontWeight: 'bold',
                }}
            >
                Ver Detalles
            </button>
        </Link>
    </div>
);


// --- Opciones de Precio para el Buscador ---
const PRICE_RANGES = [
    { label: "Menos de $10,000", min: 0, max: 9999 },
    { label: "$10,000 - $20,000", min: 10000, max: 20000 },
    { label: "$20,000 - $30,000", min: 20001, max: 30000 },
    { label: "Más de $30,000", min: 30001, max: 999999 },
];

// --- 3. Componente Principal CatalogPage ---
export default function CatalogPage() {
    // vehiclesFiltered: Lo que se muestra al usuario (ya filtrado)
    const [vehiclesFiltered, setVehiclesFiltered] = useState([]);
    // allVehicles: El listado completo (para generar las opciones dinámicas)
    const [allVehicles, setAllVehicles] = useState([]); 
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        year: '',
        make: '',
        model: '',
        priceRange: '' 
    });


    // --- 4. Generar Opciones Únicas (Años, Marcas, Modelos) ---
    // Usa useMemo para recalcular solo si allVehicles cambia
    const availableOptions = useMemo(() => {
        if (allVehicles.length === 0) return { years: [], makes: [], models: [] };

        const years = [...new Set(allVehicles.map(v => v.year).filter(Boolean).sort((a, b) => b - a))];
        const makes = [...new Set(allVehicles.map(v => v.make).filter(Boolean).sort())];
        const models = [...new Set(allVehicles.map(v => v.model).filter(Boolean).sort())];

        return { years, makes, models };
    }, [allVehicles]);


    // --- 5. Función de Fetch que aplica el filtro GraphQL ---
    const fetchVehicles = useCallback(async (currentFilters = {}) => {
        setLoading(true);
        setError(null);
        
        // --- CONSTRUCCIÓN DEL OBJETO DE FILTRO ---
        const filterInput = { status: { eq: "FOR_SALE" } };

        if (currentFilters.make) {
            filterInput.make = { eq: currentFilters.make };
        }
        if (currentFilters.model) {
            filterInput.model = { eq: currentFilters.model };
        }
        if (currentFilters.year) {
            filterInput.year = { eq: parseInt(currentFilters.year) }; 
        }
        
        if (currentFilters.priceRange) {
            const range = JSON.parse(currentFilters.priceRange);
            filterInput.price = { 
                ge: range.min, 
                le: range.max  
            };
        }
        // --- FIN CONSTRUCCIÓN DEL OBJETO DE FILTRO ---

        try {
            const response = await API.graphql({ 
                query: listVehicles,
                variables: { 
                    filter: filterInput, 
                    limit: 200 // Aumenta el límite para asegurarte de traer todo el inventario
                },
                authMode: 'API_KEY' 
            });
            
            const fetchedVehicles = response.data.listVehicles.items || [];
            
            // Si es la primera carga (sin filtros), guarda el listado completo
            if (Object.values(currentFilters).every(val => !val)) {
                setAllVehicles(fetchedVehicles.filter(v => v.status === 'FOR_SALE'));
            }
            
            // Actualiza el listado visible
            setVehiclesFiltered(fetchedVehicles.filter(v => v.status === 'FOR_SALE'));

        } catch (err) {
            console.error("Error al cargar vehículos en Catalogo:", err);
            setError("Error al cargar el listado de vehículos. Confirma que tu clave API de AppSync esté activa.");
        } finally {
            setLoading(false);
        }
    }, []); // Dependencias vacías para que solo se cree una vez


    // --- 6. Efecto para manejar la carga inicial y los cambios de filtro ---
    useEffect(() => {
        // Ejecuta la carga inicial o el filtro cuando cambie el objeto `filters`
        fetchVehicles(filters); 
    }, [filters, fetchVehicles]);
    
    // Manejar cambios en los selectores de filtro
    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        // Reinicia la paginación si la tuvieras.
        setFilters(prevFilters => ({
            ...prevFilters,
            [name]: value
        }));
    };

    const handleClearFilters = () => {
        setFilters({ year: '', make: '', model: '', priceRange: '' });
    };
    
    // --- 7. Renderizado ---
    if (loading && vehiclesFiltered.length === 0) return <div style={{ textAlign: 'center', padding: '50px' }}>Cargando Catálogo Completo...</div>;
    if (error) return <div style={{ textAlign: 'center', padding: '50px', color: 'red', fontWeight: 'bold' }}>🚨 {error} 🚨</div>;

    return (
        <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px', minHeight: '80vh' }}>
            <h1 style={{ textAlign: 'center', color: '#007bff', marginBottom: '30px', borderBottom: '2px solid #eee', paddingBottom: '15px' }}>
                Inventario Completo Miami-Fl. USA.
            </h1>

            {/* --- BUSCADOR / BARRA DE FILTROS --- */}
            <div className="filter-bar" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', padding: '20px', backgroundColor: '#ffffff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', marginBottom: '30px' }}>
                
                {/* 1. FILTRO POR AÑO */}
                <select name="year" value={filters.year} onChange={handleFilterChange} style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}>
                    <option value="">Año</option>
                    {availableOptions.years.map(year => (
                        <option key={year} value={year}>{year}</option>
                    ))}
                </select>

                {/* 2. FILTRO POR MARCA */}
                <select name="make" value={filters.make} onChange={handleFilterChange} style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}>
                    <option value="">Marca</option>
                    {availableOptions.makes.map(make => (
                        <option key={make} value={make}>{make}</option>
                    ))}
                </select>

                {/* 3. FILTRO POR MODELO */}
                <select name="model" value={filters.model} onChange={handleFilterChange} style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}>
                    <option value="">Modelo</option>
                    {availableOptions.models.map(model => (
                        <option key={model} value={model}>{model}</option>
                    ))}
                </select>

                {/* 4. FILTRO POR PRECIO */}
                <select name="priceRange" value={filters.priceRange} onChange={handleFilterChange} style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}>
                    <option value="">Precio</option>
                    {PRICE_RANGES.map((range, index) => (
                        <option 
                            key={index} 
                            value={JSON.stringify({ min: range.min, max: range.max })}
                        >
                            {range.label}
                        </option>
                    ))}
                </select>
                
                <button onClick={handleClearFilters} style={{ padding: '10px 15px', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer', backgroundColor: '#f8f9fa' }}>
                    Limpiar
                </button>
            </div>
            {/* --- FIN BUSCADOR / BARRA DE FILTROS --- */}


            {/* --- LISTADO DE VEHÍCULOS --- */}
            {vehiclesFiltered.length === 0 ? (
                <div style={{ padding: '40px', border: '1px dashed #ccc', textAlign: 'center', marginTop: '20px' }}>
                     <p style={{ fontSize: '1.2em', color: '#6c757d' }}>
                        {loading ? 'Cargando...' : 'No se encontraron vehículos que coincidan con los filtros.'}
                    </p>
                </div>
            ) : (
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px', paddingBottom: '50px' }}>
                    {vehiclesFiltered.map(v => v.id && <VehicleCard key={v.id} vehicle={v} />)}
                </div>
            )}
            
            <Footer /> 
        </main>
    );
}